export default __webpack_public_path__ + "static/media/adcetris-pro.ee03e3c5.png";